export default {
    types: {
        "ac_router": "AC router",
        "chair": "Szék",
        "desk": "Íróasztal",
        "desktop": "Asztali",
        "desktop_riser": "Asztali emelő",
        "detector": "Vape és zajérzékelő",
        "displayport_cable": "Displayport kábel",
        "docking station": "Dokkolóállomás",
        "dual_usb_adapter": "Kétsávos USB adapter",
        "ear cushion": "Fülpárna",
        "footrest": "Lábtartó",
        "hdmi_cable": "HDMI-kábel",
        "hdmi_displayport_cable": "HDMI-DisplayPort kábel",
        "hdmi_vga_cable": "HDMI-VGA kábel",
        "headset": "Fejhallgató",
        "keyboard": "Billentyűzet",
        "kvm switch": "KVM kapcsoló",
        "kvm_switch": "KVM kapcsoló",
        "lamp": "Lámpa",
        "laptop stand": "Laptop állvány",
        "laptop": "Laptop",
        "mesh_router": "Mesh router",
        "monitor": "Monitor",
        "mouse": "Egér",
        "patch_cord": "Cat6 patch kábel",
        "power": "Tápkábel",
        "power_center": "Energiaközpont",
        "power_strip": "Elosztó",
        "printer": "Nyomtató",
        "smart_plug": "Mini okoscsatlakozó",
        "smart_power_strip": "Okos elosztó",
        "speakerphone": "Kihangosító",
        "stylus": "Érintőceruza",
        "tablet": "Tabletta",
        "tablet accessory": "Táblagép-kiegészítő",
        "thunderbolt_cable": "USB-C – Thunderbolt",
        "travel_router": "Utazó router",
        "usb hub": "USB-elosztó",
        "usb_adapter": "USB-adapter",
        "usb_hub": "USB-elosztó",
        "webcam": "Webkamera"
    }
}